import dynamic from 'next/dynamic';

export const AppInstallBannerDynamic = dynamic(
  async () => import('./index').then((mod) => mod.AppInstallBanner),
  {
    ssr: false,
    loading: () => null,
  }
);
